// Testimonials.js
"use client";
import { useRef, useState } from "react";
import testimonialData from "@/data/testimonials";
import Image from "next/image";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const Testimonials = ({ userType, title }) => {
      const filteredTestimonials = userType
            ? testimonialData.filter((td) => td.userType === userType)
            : testimonialData;

      const swiperRef = useRef(null);
      const [isAtStart, setIsAtStart] = useState(true);

      const updateSwiperEdgeState = (swiper) => {
            if (!swiper) return;
            setIsAtStart(swiper.isBeginning);
      };

      const handlePrev = () => {
            if (swiperRef.current) {
                  swiperRef.current.slidePrev();
                  updateSwiperEdgeState(swiperRef.current);
            }
      };

      const handleNext = () => {
            if (swiperRef.current) {
                  swiperRef.current.slideNext();
                  updateSwiperEdgeState(swiperRef.current);
            }
      };

      return (
            <>
                  <div className="row align-items-center justify-content-between mb30">
                        <div className="col-auto">
                              <h3 className="h3" style={{ marginBottom: 0 }}>
                                    {title}
                              </h3>
                        </div>
                  </div>

                  {/* Pagination dot buttons */}
                  <div className="testimonial-dot-nav">
                        <button
                              type="button"
                              className={`testimonial-dot-btn ${isAtStart ? "active" : ""}`}
                              onClick={handlePrev}
                              aria-label="Previous testimonials"
                        />
                        <button
                              type="button"
                              className={`testimonial-dot-btn ${!isAtStart ? "active" : ""}`}
                              onClick={handleNext}
                              aria-label="Next testimonials"
                        />
                  </div>

                  <Swiper
                        className="overflow-visible testimonial-swiper"
                        spaceBetween={10}
                        modules={[Navigation, Pagination]}
                        onSwiper={(swiper) => {
                              swiperRef.current = swiper;
                              updateSwiperEdgeState(swiper);
                        }}
                        onSlideChange={(swiper) => {
                              updateSwiperEdgeState(swiper);
                        }}
                        navigation={{
                              nextEl: ".testimonila_next__active",
                              prevEl: ".testimonila_prev__active",
                        }}
                        pagination={{
                              el: ".testimonila_pagination__active",
                              clickable: true,
                        }}
                        breakpoints={{
                              300: { slidesPerView: 1 },
                              768: { slidesPerView: 2 },
                              1024: { slidesPerView: 2 },
                              1200: { slidesPerView: 3 },
                        }}
                  >
                        {filteredTestimonials.map((t) => {
                              const isLandLord = t.userType === "land-lord";

                              return (
                                    <SwiperSlide key={t.id} className="h-100 d-flex">
                                          <div
                                                className="item d-flex flex-column w-100 h-100"
                                                style={{ maxWidth: 355, overflow: "hidden" }}
                                          >
                                                <div
                                                      className="testimonial-style1 d-flex flex-column flex-1 h-100"
                                                      style={{
                                                            backgroundColor: isLandLord ? "#FFFBEB" : "#ffffff",
                                                      }}
                                                >
                                                      <div className="testimonial-content flex-grow-1">
                                                            {/* Title left, quote icon right */}
                                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                                  <h5 className="title mb-0">{t.title}</h5>
                                                                  <span
                                                                        className="icon fas fa-quote-left ms-3"
                                                                        style={{
                                                                              fontSize: "1.5rem",
                                                                              position: "static",
                                                                              flexShrink: 0,
                                                                              color: isLandLord ? "#FEF3C7" : "#E6EFFA",
                                                                        }}
                                                                  />
                                                            </div>

                                                            <p
                                                                  className="text text-4-lines"
                                                                  style={{ minHeight: 105 }}
                                                            >
                                                                  {t.quote}
                                                            </p>

                                                            <div className="testimonial-review">
                                                                  {Array.from({ length: t.stars }, (_, i) => (
                                                                        <a className="me-1" href="#" key={i}>
                                                                              <i className="fas fa-star" />
                                                                        </a>
                                                                  ))}
                                                            </div>
                                                      </div>

                                                      <div
                                                            style={{
                                                                  display: "flex",
                                                                  alignItems: "center",
                                                                  justifyContent: "space-between",
                                                                  paddingRight: 8,
                                                            }}
                                                      >
                                                            <div className="thumb d-flex align-items-center mt-auto">
                                                                  {/* Avatar */}
                                                                  <div className="flex-shrink-0">
                                                                        <div
                                                                              style={{
                                                                                    width: 60,
                                                                                    height: 60,
                                                                                    borderRadius: "50%",
                                                                                    overflow: "hidden",
                                                                                    border: isLandLord ? "3px solid #FFD26A" : "none",
                                                                                    position: "relative",
                                                                              }}
                                                                        >
                                                                              <Image
                                                                                    src={t.image}
                                                                                    alt="avatar"
                                                                                    fill
                                                                                    sizes="60px"
                                                                                    style={{ objectFit: "cover" }}
                                                                              />
                                                                        </div>
                                                                  </div>
                                                                  <div className="flex-grow-1 ms-3">
                                                                        <h6 className="mb-0">{t.name}</h6>
                                                                        <p className="mb-0 text-secondary">{t.company}</p>
                                                                  </div>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </SwiperSlide>
                              );
                        })}
                  </Swiper>
            </>
      );
};

export default Testimonials;
